import { GatsbySeo } from 'gatsby-plugin-next-seo'
import React from 'react'
import Layout from '../components/Layout'
import { PhotoPlaceholder } from 'react-placeholder-image';

function renderImage({image, title}) {
  if (image !== false) {
    if (image) {
      var imageSrc = image
    } else {
      var imageSrc = "/img/5.jpg"
    }
    return (
      <div className="relative w-full flex flex-col">
        <img src={imageSrc} alt={title} />
        <div className="absolute top-0 lg:p-8 w-full text-4xl flex items-center justify-center text-white h-full">
            <h1 className="bg-gray-800 p-4 uppercase m-0 font-kanit">{title}</h1>
          </div>
      </div>
    )
  }
}
export default function Page({ title, description, image, children }) {

  return (
<Layout>
    <GatsbySeo title={title} description={description} />
    <div className="container w-full xl:w-1/2 lg:my-16 mx-auto flex text-center flex-col items-center">
        {/* <PhotoPlaceholder width={800} height={200} grayscale className="w-full"/> */}
        {/* <StaticImage src={image} formats={['auto', 'webp', 'avif']} className="w-full" alt=""/> */}
      {renderImage({image, title})}
      <div className=" flex items-center flex-col  w-full text-center p-8 border bg-gray-100">{children}</div>
    </div>
  </Layout>
  )
}